module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <ng-container *ngFor=\"let party of onyxEvent.eventVendors\">\n        <pioneer-invoice-history-vendor-card\n          [vendors]=\"onyxEvent.eventVendors\"\n          [vendor]=\"party\"\n          [event]=\"onyxEvent\">\n        </pioneer-invoice-history-vendor-card>\n      </ng-container>\n\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor/invoice-history-vendor.component.html
// module id = cmeK
// module chunks = 0